import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { People, PerformanceGoalControllerClient } from '~/services/Http';

export const GET_TEAM_PERFORMANCE_SCORE_SWR_KEY =
  'PerformanceGoalControllerClient.useGetTeamPerformanceScores';

export function useGetTeamPerformanceScores(
  args: {
    employeeId: string;
    lang?: string;
    offset?: number;
    limit?: number;
    order?: People.Order24;
    treeId?: string;
    roles?: string[];
    unitIds?: number[];
  },
  swrConfig?: SWRConfiguration<People.PerformanceGoalDto[]>,
): UseSWROutput<People.PerformanceGoalDto[]> {
  return useSWR(
    [
      GET_TEAM_PERFORMANCE_SCORE_SWR_KEY,
      args.employeeId,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.order ?? undefined,
      args?.treeId ?? undefined,
      args?.unitIds ?? undefined,
      args?.roles ?? undefined,
    ],
    ([_, employeeId, lang, offset, limit, order, treeId, unitIds, roles]) =>
      PerformanceGoalControllerClient.getTeamPerformanceScores(
        employeeId,
        order,
        offset,
        lang,
        limit,
        treeId,
        roles,
        unitIds,
      ).then((r) => r.data),
    swrConfig,
  );
}
